// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { ASSESSOR_MODULE, ASSESSOR_URL } from 'constant/url.constant'

// Constant
import { LAYOUT } from 'constant/layout.constant'

// UI
const { AssessorIndex } = lazily(() => import('pages/webpage/assessor'))

const assessorRoutes: IRoute[] = [
  {
    path: ASSESSOR_URL.INDEX,
    component: AssessorIndex,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: ASSESSOR_MODULE,
      requireAuth: false,
      attrs: {
        label: 'assessor.assessor',
      },
    },
  },
]

export { assessorRoutes }
